import React from "react";

const PrivacyPolicyEn = () => {
  return (
    <div className="container mx-auto px-4 py-8 text-onWhite">
      <h1 className="text-center text-3xl font-bold mb-6">PRIVACY POLICY</h1>
      <p className="text-center text-lg mb-6">
        ANANAS SOLUTIONS – A product of Ananas Acti-Solutions Inc.
      </p>
      <p className="text-center mb-4">
        <strong>Last updated: October 2, 2025</strong>
      </p>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">
          1. Personal Information Officer
        </h2>
        <p>
          The Privacy Officer for <strong>Ananas Acti-Solutions Inc.</strong>{" "}
          can be reached at:{" "}
          <a
            href="mailto:privacy@ananassolutions.com"
            className="text-blue-500 underline"
          >
            privacy@ananassolutions.com
          </a>
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">
          2. Personal Information Collected
        </h2>
        <ul className="list-disc ml-8">
          <li>Name, email address, phone number</li>
          <li>Mailing address and billing information</li>
          <li>Login data (IP address, logs, cookies)</li>
          <li>Preferences, navigation history, interactions</li>
          <li>Payment and transaction details</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">3. Purposes</h2>
        <ul className="list-disc ml-8">
          <li>To provide services and fulfill contracts</li>
          <li>To manage subscriptions and transactions</li>
          <li>To offer customer support and communication</li>
          <li>To improve our products, services, and security</li>
          <li>To comply with legal and tax obligations</li>
          <li>To send promotional content (if consented)</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">
          4. Third-Party Disclosure
        </h2>
        <p>
          Your data may be shared with service providers (e.g., Stripe for
          payments, SendGrid for emails, carriers for delivery). They only have
          access to what is necessary to provide their services and must protect
          it accordingly.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">
          5. Retention and Deletion
        </h2>
        <p>
          We retain your data only as long as necessary for the intended
          purposes, or as required by law (e.g., 7 years for accounting
          documents). If you delete your account, your data will be erased
          within 3 months, unless legal obligations require otherwise.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">
          6. Transfers Outside Quebec
        </h2>
        <p>
          Some personal information may be hosted or processed outside Quebec
          (e.g., Stripe, Supabase, SendGrid). We ensure they provide adequate or
          equivalent protection levels.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">7. Security</h2>
        <p>
          We use reasonable technical and organizational measures (encryption,
          restricted access, secure servers) to protect your information.
          However, no system is completely secure.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">8. Your Rights (Law 25)</h2>
        <ul className="list-disc ml-8">
          <li>Access your personal information</li>
          <li>Request correction</li>
          <li>Request deletion (right to be forgotten)</li>
          <li>Withdraw consent at any time</li>
        </ul>
        <p>
          To exercise these rights, contact:{" "}
          <a
            href="mailto:privacy@ananassolutions.com"
            className="text-blue-500 underline"
          >
            privacy@ananassolutions.com
          </a>
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicyEn;
